import toast from 'react-hot-toast'

/**
 * This function can be used for handling uncommon errors coming from server.
 * @param {(key: string) => string | React.ReactNode} t - translation function
 * @param {() => void} callback - function to be called after showing message
 *
 */
export const handleAxiosError = (t, callback = () => {}) => {
  return (error) => {
    console.warn(error)
    toast.error(t('common.errors.something_went_wrong'))

    callback()
  }
}
